import { render, staticRenderFns } from "./FormLegalDetail.vue?vue&type=template&id=7693519e&"
import script from "./FormLegalDetail.vue?vue&type=script&lang=js&"
export * from "./FormLegalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7693519e')) {
      api.createRecord('7693519e', component.options)
    } else {
      api.reload('7693519e', component.options)
    }
    module.hot.accept("./FormLegalDetail.vue?vue&type=template&id=7693519e&", function () {
      api.rerender('7693519e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/legal-detail/form/FormLegalDetail.vue"
export default component.exports